import { login } from "../../../api/auth";
import axios from "../../../api/axios";

const useLogin = () => {
  const authenticate = async (form) => {
    const { data, token, error } = await axios.post("/users/login", {
      ...form,
      requiredRoles: ["SUPER_ADMIN"],
    });

    if (error) throw new Error(error);
    login({ data, token, isBackoffice: true });

    return data;
  };

  return { authenticate };
};

export default useLogin;
